import { useContext } from 'react';
import { useTheme, makeStyles, Card, TableFooter, Tooltip, Zoom } from '@material-ui/core';
import { Table, TableHead, TableBody, TableCell, TableRow, Typography, CardContent, TablePagination } from '@material-ui/core';
import { PriorityHigh as ErrorIcon } from '@material-ui/icons';
import Moment from 'react-moment';
import { CircleLoader, Page, PageHeader } from 'components';
import { importRequestsContext } from './ImportRequestsContext';
import { applicationContext } from 'helpers/services';


let useStyles = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(3)
    },
    content: {
        padding: 0
    }
}));

let Results = () => {
    let theme = useTheme();
    let classes = useStyles(theme);

    let service = useContext(importRequestsContext);
    let appService = useContext(applicationContext);

    return (
        <>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <Page>
                    <PageHeader pageTitle="Excel Import Requests" />
                    <Card>
                        <CardContent className={classes.content}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Filename</TableCell>
                                        <TableCell>Country</TableCell>
                                        <TableCell>Start</TableCell>
                                        <TableCell>End</TableCell>
                                        <TableCell />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {service.excelImportRequests
                                        .map(request =>
                                            <TableRow key={request.requestId}>
                                                <TableCell>{request.fileName}</TableCell>
                                                <TableCell>{appService.referenceData.countries.getValueByKey(request.country)}</TableCell>
                                                <TableCell>
                                                    {request.dateStart && <Moment date={request.dateStart} format="LLL" />}
                                                    {!request.dateStart && "Not started"}
                                                </TableCell>
                                                <TableCell>
                                                    {request.dateEnd && <Moment date={request.dateEnd} format="LLL" />}
                                                    {!request.dateEnd && "Not completed"}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {request.errors &&
                                                        <Tooltip TransitionComponent={Zoom} title={request.errors}>
                                                            <ErrorIcon color="error" />
                                                        </Tooltip>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )}
                                </TableBody>
                                {service.excelImportRequests.length === 0 &&
                                    <TableFooter>
                                        <TableRow>
                                            <TableCell colSpan={7}>
                                                <Typography variant="subtitle2">No requests found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableFooter>
                                }
                            </Table>
                            <TablePagination
                                component="div"
                                count={service.excelImportCount}
                                onPageChange={(e: any, page: number) => service.handleChangePage(page)}
                                page={service.excelImportPageNr}
                                rowsPerPage={service.pageSize}
                                rowsPerPageOptions={[service.pageSize]}
                                labelDisplayedRows={({ page, count }) =>
                                    <span>Page {page + 1} of {Math.ceil(count / service.pageSize)}. {count} requests found</span>
                                }
                            />
                        </CardContent>
                    </Card>

                </Page>
            }
        </>


    )
}

export default Results;